import React, {useEffect, useMemo} from "react"
import {Outlet, ScrollRestoration, useMatches, useRouter} from "@tanstack/react-router"
import {TanStackRouterDevtools} from "@tanstack/router-devtools"
import {ReactQueryDevtools} from "@tanstack/react-query-devtools"
import {PageDef} from "@/library/types/pages"
import ToastsList from "@/components/ui-kit/toasts-list"
import DocumentTitle from "@/components/page-meta/page-title"

const debugMode = false

export default function RootLayout() {
    const matches = useMatches()
    const router = useRouter()

    const passedInfo = useMemo(() =>
            Object.entries(matches.last().staticData).find(e => e[0] == "pageInfo")?.at(1) ?? {}
        , [matches])

    const info: PageDef = router.hasNotFoundMatch()
        ? {
            pageTitle: 'Side ikke funnet'
        }
        : passedInfo

    return <>
        <DocumentTitle title={info.pageTitle ?? info.navName} />

        <ToastsList
            position="bottom-right"
            category="global"
        />

        <Outlet />

        {debugMode && <>
            <TanStackRouterDevtools
                position="top-right"
                initialIsOpen={false}
            />
            <ReactQueryDevtools
                buttonPosition="top-right"
                initialIsOpen={false}
            />
        </>}
    </>
}
